mutation DeleteJob($jobId: ID!) {
    deleteJob(jobId: $jobId) {
        _id
        status
        message
    }
}
